import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="relative flex min-h-screen items-center justify-center bg-ink px-4">
      <div className="absolute inset-0 bg-blueprint opacity-30" />
      <form onSubmit={onSubmit} className="relative w-full max-w-md border border-line bg-panel p-10">
        <div className="flex items-center gap-4">
          <img src="/neo-logo.png" alt="NEO CONSTRUCTION" className="h-12 w-auto rounded-[6px]" />
          <span className="font-mono text-[10px] tracking-[0.35em] text-gray-500">ADMIN</span>
        </div>
        <h1 className="mt-8 font-mincho text-2xl font-bold text-white">管理画面ログイン</h1>
        {error && (
          <p data-testid="login-error" className="mt-6 border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-400">
            {error}
          </p>
        )}
        <label className="mt-8 block">
          <span className="font-mono text-[10px] tracking-[0.3em] text-gray-500">EMAIL</span>
          <input
            data-testid="login-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full border border-line bg-ink px-4 py-3 text-sm text-white outline-none transition-colors focus:border-accent"
            placeholder="admin@neo-construction.jp"
          />
        </label>
        <label className="mt-5 block">
          <span className="font-mono text-[10px] tracking-[0.3em] text-gray-500">PASSWORD</span>
          <input
            data-testid="login-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full border border-line bg-ink px-4 py-3 text-sm text-white outline-none transition-colors focus:border-accent"
            placeholder="••••••••"
          />
        </label>
        <button
          data-testid="login-submit-button"
          type="submit"
          disabled={loading}
          className="mt-8 w-full bg-accent py-3.5 font-display text-sm font-bold tracking-[0.2em] text-ink transition-colors hover:bg-accent-hover disabled:opacity-50"
        >
          {loading ? "認証中..." : "ログイン"}
        </button>
        <Link to="/" className="mt-6 block text-center text-xs text-gray-500 transition-colors hover:text-white">
          ← 公開サイトへ戻る
        </Link>
      </form>
    </div>
  );
}
